import {
    cartAccountFromQuerySelector,
    cartAccountSelector,
    cartAutoUpgradeSelector,
    cartCurrencySelector,
    cartDomainsFromQuerySelector,
    cartDomainsSelector,
    cartExtraFromQuerySelector,
    cartExtraPackageFlagSelector,
    cartIncludedProductIdsSelector,
    cartMainProduct,
    cartRenewSelector,
    uiModeFromQuery,
} from '../redux/selectors/cartSelector';

/**
 * Returns values of the currently selected filters/form controls.
 *
 * Refactored version of the function decoupled from the src/redux/actions/cartAction.js.
 *
 * @param getState
 * @param [params] - override or additional parameters
 * @returns {*&{period_interval: *, tariff_id: *, period: *, featured: *, product_id: *, currency: *, renew, fua: *}}
 */
export default (getState, params = {}) => {
    const state = typeof getState === 'function' ? getState() : getState;
    const productCurrent = cartMainProduct(state);
    const renew = cartRenewSelector(state);
    const productsIncluded = cartIncludedProductIdsSelector(state);
    const currency = cartCurrencySelector(state);
    const uiMode = uiModeFromQuery(state);

    let extraPackageFlag = null;

    if (productCurrent) {
        extraPackageFlag =
            productCurrent?.includeExtra === null
                ? cartExtraFromQuerySelector(state)
                : cartExtraPackageFlagSelector(state);
    }

    const autoUpgradeFlag = cartAutoUpgradeSelector(state);
    let domains = cartDomainsSelector(state);
    let account = cartAccountSelector(state);

    if (!domains || !domains.length || !domains[0]) {
        domains = cartDomainsFromQuerySelector(state);
    }

    if (!account) {
        account = cartAccountFromQuerySelector(state);
    }

    const productsIncludedTest =
        productsIncluded?.length > 0
            ? productsIncluded?.filter((id) => id !== productCurrent?.product_id)?.join(',')
            : null;

    let result = cleanObject({
        product_id: productCurrent?.product_id,
        tariff_id: productCurrent?.tariff?.tariff_id,
        period: productCurrent?.period?.billing_period,
        period_interval: productCurrent?.period?.interval,
        currency: currency?.currency,
        renew: renew,
        extra: extraPackageFlag,
        domains: domains,
        fua: autoUpgradeFlag,
        featured: productsIncludedTest,
        account: account,
        ...params,
    });

    if (uiMode) {
        result.ui_mode = uiMode;
    }

    // Workaround the issue with inconsistency in period fields naming in data structures / API.
    if (!result?.period && result?.period_interval) {
        result.period = productCurrent?.period?.interval;
        result.period_interval = productCurrent?.period?.interval_count;
    }

    return result;
};

function cleanObject(obj) {
    const newObj = {};
    for (const key in obj) {
        if (obj[key] == null || obj[key]?.length === 0 || obj[key] === '') {
            continue;
        }
        newObj[key] = obj[key];
    }
    return newObj;
}
